import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NGXLogger } from 'ngx-logger';
import { INotice, NoticeService } from 'src/services/notice.service';
import { PopupDialogComponent } from '../popup-dialog/popup-dialog.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  notices: Array<INotice> = [];

  postData: any = [];

  constructor(
    private dialog: MatDialog
    , private noticeSvc: NoticeService
    , private logger: NGXLogger) {
  }

  ngOnInit() {
    const now = new Date().getTime();
    this.noticeSvc.retrieveAll()
      .subscribe(res => {
        const notices = res as Array<INotice>;
        this.notices = notices.filter(n => n.isPopup && now >= this.dateFromTime(n.dateFrom) && now <= this.dateToTime(n.dateTo));

        for (let i = 0; i < this.notices.length; i++) {
          if (localStorage.getItem(String(this.notices[i].id))) {
            this.getLocalStorageWithExpiry(this.notices[i]);
          } else {
            this.postData.push(this.notices[i]);
          }
        }

        if (this.postData.length > 0) {
          this.dialog.open(PopupDialogComponent, {
            data: this.postData,
            maxWidth: '100vw',
            maxHeight: '100vh',
            height: '60%',
            width: '60%',

          });
        }

        //for (let i = 0; i < this.notices.length; i++) {

        //    if (localStorage.getItem(String(this.notices[i].id))) {
        //      this.getLocalStorageWithExpiry(this.notices[i]);
        //    }
        //    else {
        //      //팝업여러개 출력되도록 수정
        //      //if (i ==0) {
        //        this.dialog.open(PopupDialogComponent, { data: this.notices[i] });
        //      //}
        //    }

        //}
        this.logger.log("notices", this.notices);
      });
  }

  getLocalStorageWithExpiry(key: INotice) {
    const now = new Date().getTime();
    const ttl = JSON.parse(localStorage.getItem(String(key.id))).ttl;
    if (now > ttl) {
      localStorage.removeItem(String(key.id));
      this.dialog.open(PopupDialogComponent, { data: key });
    }
  }

  dateFromTime(date: Date) {
    const year = new Date(date).getFullYear();
    const month = new Date(date).getMonth();
    const day = new Date(date).getDate();
    return new Date(year, month, day).getTime();
  }

  dateToTime(date: Date) {
    const year = new Date(date).getFullYear();
    const month = new Date(date).getMonth();
    const day = new Date(date).getDate() + 1;
    return new Date(year, month, day).getTime();
  }
}
